import * as React from 'react';
import { PbrInputTextArea } from 'src/components/common/PbrInputTextArea/PbrInputTextArea';
import { Spin } from 'antd';

interface IPropsConfirmModalRejectPrePrecatorio {
    reasonPlaceholder: string
    modalLoading: boolean;
    onReasonChange: (s: string) => void;
}

export const ConfirmModalRejectPrePrecatorio: React.FC<IPropsConfirmModalRejectPrePrecatorio> = ({
    modalLoading,
    onReasonChange,
    reasonPlaceholder
}) => {

    const [reason, setReason] = React.useState<string>("");

    return (
        <Spin spinning={modalLoading}>
            <React.Fragment>
                <PbrInputTextArea
                    name="reason"
                    rules={[
                        {
                            required: true,
                            message: "Campo Obrigatório"
                        }
                    ]}
                    value={reason}
                    onChange={e => {
                        setReason(e.target.value);
                        onReasonChange(e.target.value);
                    }}
                    placeholder={reasonPlaceholder}
                    autosize={{ minRows: 2, maxRows: 6 }}
                />
            </React.Fragment>
        </Spin >
    );
}


// WEBPACK FOOTER //
// ./src/components/Refatoracao/RejectPrePrecatorio/ConfirmModalRejectPrePrecatorio.tsx